<template>
  <section class="section">
    <div class="section-body">
      <div class="card">
        <div class="card-header">
          <v-icon color="pink">edit</v-icon>
          <h4>{{ $t("messages.general.manageData") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.academicYear") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearChanged"
                      :selectedVal="selYear"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.semester") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelSemesterChanged"
                      :selectedVal="selSemester"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.educationLvl") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Level
                      :onChanged="onSelLvlChanged"
                      :selectedVal="selLvl"
                      :disabled="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.classCode") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="input-group">
                            <div class="form-inline">
                              <div class="input-group-append">
                                <input
                                  type="text"
                                  class="form-control col mr-2"
                                  style="margin-right: 0px !important"
                                  v-model="courseCode"
                                  @keypress="handleSearchClsKey($event)"
                                />
                                <button
                                  type="button"
                                  class="btn btn-temp btn-lg"
                                  @click="handleSearchCls()"
                                >
                                  <i class="fas fa-search"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              disabled
                              v-model="courseName"
                            />
                            <button
                              type="button"
                              class="btn btn-danger btn-lg"
                              @click="handleClrScreen()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.section") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select
                        class="form-control"
                        @change="onSelSectionChanged($event)"
                      >
                        <option :selected="selSection == '00'" value="00"
                          >---{{
                            $t("messages.general.notSpecified")
                          }}---</option
                        >
                        <option
                          v-for="(item, index) in sections"
                          :key="index"
                          :value="item.SECTION_TEXT"
                          :selected="selSection == item.SECTION_TEXT"
                        >
                          {{ item.SECTION_TEXT }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.typeOfCourse") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <GetClassType
                      :onChanged="onSelTypeChanged"
                      :selectedVal="selType"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group" style="width: 100%">
                <div class="form-inline">
                  <div
                    class="form-group"
                    style="width: 60%; justify-content: center;"
                  >
                    <div class="form-inline">
                      <button
                        type="button"
                        class="btn btn-primary btn-lg"
                        @click="handleSearchResult()"
                      >
                        {{ $t("messages.general.search") }}</button
                      >&nbsp;&nbsp;&nbsp;
                      <button
                        type="button"
                        class="btn btn-light btn-lg"
                        @click="handleClearScreen()"
                      >
                        {{ $t("messages.general.clearScreen") }}</button
                      >&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                  <div
                    class="form-group"
                    style="width: 40%; justify-content: flex-end;"
                  >
                    <div class="form-inline">
                      <button
                        type="button"
                        class="btn btn-primary btn-lg"
                        @click="EditNumberOfSet()"
                        :disabled="bTable.items.length > 0 && bTable.items[0].SHOW_BUTTONEDITALL == 'N'"
                      >
                        {{ $t("messages.general.editAmountMulti") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group" style="width: 100%">
                <div class="form-inline">
                  <div
                    class="form-group"
                    style="width: 60%; justify-content: center;"
                  >
                    <div class="form-inline">
                      &nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                  <div
                    class="form-group"
                    style="width: 40%; justify-content: flex-end;"
                  >
                    <div class="form-inline">
                      <button
                        type="button"
                        class="btn btn-primary btn-lg"
                        @click="handleSaveNumber()"
                      >
                        <span class="material-icons">
                          save
                        </span></button
                      >&nbsp;&nbsp;&nbsp;
                      <button
                        type="button"
                        class="btn btn-primary btn-lg"
                        @click="handleCancelNum()"
                      >
                        <span class="material-icons">
                          close
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTable.sortBy"
              :sort-desc.sync="bTable.sortDesc"
              :items="bTable.items"
              :fields="bTable.fields"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTable.items.length"
                  v-model="currentPage"
                  :per-page="perPage"
                />
                <div
                  v-if="bTable.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPage > 1
                        ? (currentPage - 1) * perPage + 1
                        : currentPage
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPage * perPage > bTable.items.length
                        ? bTable.items.length
                        : currentPage * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTable.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
              </template>
              <template v-slot:head(action)="">
                <input
                  type="checkbox"
                  id="chkDelAll"
                  @change="handleChkAll($event)"
                  :checked="
                    bTable.items.length > 0 &&
                      bTable.items.length == courseList.length
                  "
                />
              </template>
              <template v-slot:cell(action)="data">
                <input
                  type="checkbox"
                  id="chkDel"
                  @change="handleChk($event, data)"
                  :checked="data.value"
                />
              </template>

              <template v-slot:cell(CONFIRMQTY)="data">
                <a
                  @click="handleSelectTotalConfirm(data.item, data.index)"
                  style="text-decoration: underline;"
                >
                  {{ data.item.CONFIRMQTY }}
                </a>
              </template>
              <template v-slot:cell(ENROLLSEAT)="data">
                <a
                  @click="handleSelectTotalEnroll(data.item, data.index)"
                  style="text-decoration: underline;"
                >
                  {{ data.item.ENROLLSEAT }}
                </a>
              </template>

              <template v-slot:cell(TOTALSUMSEAT)="data">
                <div class="text-center">
                  <input
                    type="number"
                    :max="data.item.CAPACITYLIST"
                    min="0"
                    class="form-control col mr-2"
                    style="text-align:right"
                    v-model="data.item.TOTALSUMSEAT"
                    :disabled="!data.item.checked"
                  />
                </div>
              </template>
              <template v-slot:cell(ROOMNAME)="data">
                <div v-html="data.item.ROOMNAME">
                  {{ data.item.ROOMNAME }}
                </div>
              </template>
              <template v-slot:cell(CAPACITYLIST)="data">
                <div v-html="data.item.CAPACITYLIST">
                  {{ data.item.CAPACITYLIST }}
                </div>
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTable.items.length"
                    v-model="currentPage"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTable.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPage > 1
                          ? (currentPage - 1) * perPage + 1
                          : currentPage
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPage * perPage > bTable.items.length
                          ? bTable.items.length
                          : currentPage * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTable.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>

          <v-dialog
            v-model="dialogSearchProgram"
            hide-overlay
            scrollable
            max-width="80%"
          >
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>search</v-icon>
                <v-toolbar-title>{{
                  $t("messages.general.classList")
                }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogSearchProgram = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark>
                <form>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.classId") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            <input
                              v-model="dlgCourseCode"
                              type="text"
                              class="form-control col mr-2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.className") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            <input
                              v-model="dlgCourseName"
                              type="text"
                              class="form-control col mr-2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.faculty") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <Faculty
                            :onChanged="onSelFacultyCourseChanged"
                            :selectedVal="selFacultyCourse"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.department") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <Department
                            :onChanged="onSelDepartmentCourseChanged"
                            :facultyid="selFacultyCourse"
                            :selectedVal="selDepartmentCourse"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-row flex-column justify-content-center align-items-center mt-5"
                  >
                    <div class="form-group">
                      <div class="form-inline">
                        <button
                          class="btn btn-primary btn-lg"
                          type="button"
                          @click="handleCourseSearch()"
                        >
                          {{ $t("messages.general.search") }}</button
                        >&nbsp;&nbsp;&nbsp;
                        <button
                          class="btn btn-light btn-lg"
                          type="button"
                          @click="clearCourseProgram()"
                        >
                          {{ $t("messages.general.clearScreen") }}</button
                        >&nbsp;&nbsp;&nbsp;
                      </div>
                    </div>
                  </div>
                </form>
                <v-card>
                  <b-table
                    bordered
                    hover
                    small
                    responsive
                    caption-top
                    class="table table-striped text-center"
                    :sort-by.sync="bTableProgram.sortBy"
                    :sort-desc.sync="bTableProgram.sortDesc"
                    :items="bTableProgram.items"
                    :fields="bTableProgram.fields"
                    :per-page="perPage"
                    :current-page="currentPageProgram"
                  >
                    <template slot="table-caption">
                      <div class="float-left">
                        <b class="mr-2">{{
                          $t("messages.general.table.paginationinfo")
                        }}</b>
                        <b-form-select
                          v-model="perPage"
                          :options="perPageOptions"
                          size="sm"
                          style="width:70px"
                        />
                      </div>
                      <b-pagination
                        class="float-right"
                        size="sm"
                        :total-rows="bTableProgram.items.length"
                        v-model="currentPageProgram"
                        :per-page="perPage"
                      />
                      <div
                        v-if="bTableProgram.items.length > 0"
                        class="float-right data-table-page-info"
                      >
                        {{
                          Number(
                            currentPageProgram > 1
                              ? (currentPageProgram - 1) * perPage + 1
                              : currentPageProgram
                          ).toLocaleString()
                        }}
                        -
                        {{
                          Number(
                            currentPageProgram * perPage >
                              bTableProgram.items.length
                              ? bTableProgram.items.length
                              : currentPageProgram * perPage
                          ).toLocaleString()
                        }}
                        {{ $t("messages.general.fromRecords") }}
                        {{
                          Number(bTableProgram.items.length).toLocaleString()
                        }}
                      </div>
                      <div
                        v-if="bTableProgram.items.length <= 0"
                        class="float-right data-table-page-info"
                      >
                        0 - 0
                        {{ $t("messages.general.fromRecords") }}
                        {{
                          Number(bTableProgram.items.length).toLocaleString()
                        }}
                      </div>
                    </template>

                    <template v-slot:cell(COURSECODE)="data">
                      <a
                        @click="handleSelectCourse(data.item, data.index)"
                        style="text-decoration: underline;"
                      >
                        {{ data.item.COURSECODE }}
                      </a>
                    </template>

                    <template slot="table-caption">
                      <div
                        style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                      >
                        <div class="float-left">
                          <b class="mr-2">{{
                            $t("messages.general.table.paginationinfo")
                          }}</b>
                          <b-form-select
                            v-model="perPage"
                            :options="perPageOptions"
                            size="sm"
                            style="width:70px"
                          />
                        </div>
                        <b-pagination
                          class="float-right"
                          size="sm"
                          :total-rows="bTableProgram.items.length"
                          v-model="currentPageProgram"
                          :per-page="perPage"
                          style="padding-top: 10px"
                        />
                        <div
                          v-if="bTableProgram.items.length > 0"
                          class="float-right data-table-page-info"
                          style="padding-top: 14px"
                        >
                          {{
                            Number(
                              currentPageProgram > 1
                                ? (currentPageProgram - 1) * perPage + 1
                                : currentPageProgram
                            ).toLocaleString()
                          }}
                          -
                          {{
                            Number(
                              currentPageProgram * perPage >
                                bTableProgram.items.length
                                ? bTableProgram.items.length
                                : currentPageProgram * perPage
                            ).toLocaleString()
                          }}
                          {{ $t("messages.general.fromRecords") }}
                          {{
                            Number(bTableProgram.items.length).toLocaleString()
                          }}
                        </div>
                        <div
                          v-if="bTableProgram.items.length <= 0"
                          class="float-right data-table-page-info"
                          style="padding-top: 14px"
                        >
                          0 - 0
                          {{ $t("messages.general.fromRecords") }}
                          {{
                            Number(bTableProgram.items.length).toLocaleString()
                          }}
                        </div>
                      </div>
                    </template>
                  </b-table>
                </v-card>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogConfirmSuccess" max-width="600px">
            <v-card tile>
              <v-toolbar flat dense color="light-green accent-3">
                <v-icon color="light-green darken-2">fa-check</v-icon>
                <v-toolbar-title style="color: green;"
                  >&nbsp;{{
                    $t("messages.reqRegister.confirmPopupText")
                  }}</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogConfirmSuccess = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark color="green accent-1">
                <br />
                <span v-html="successText" style="color: green;">{{
                  successText
                }}</span>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogError" max-width="600px">
            <v-card tile>
              <v-toolbar flat dense color="red darken-3">
                <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
                <v-toolbar-title style="color: #ffebee;"
                  >&nbsp;{{ dialogErrorTitle }}</v-toolbar-title
                >
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogError = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark color="red accent-1">
                <br />
                <span style="color: red;" v-html="errorText">{{
                  errorText
                }}</span>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogEditAmountMulti"
            hide-overlay
            scrollable
            max-width="50%"
          >
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>edit</v-icon>
                <v-toolbar-title>{{
                  $t("messages.general.editAmountMulti")
                }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogEditAmountMulti = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark>
                <div class="form-row">
                  <div class="col no-padding-bottom">
                    <div class="information-detail-white">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 10em;"
                      >
                        <label>{{
                          $t("messages.general.improveAmount")
                        }}</label>
                      </div>
                      <div class="col no-margin-padding">
                        <div>
                          <input
                            v-model="dlgImproveAmount"
                            type="number"
                            class="form-control col mr-2"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="form-row flex-column justify-content-center align-items-center mt-5"
                >
                  <div class="form-group">
                    <div class="form-inline">
                      <button
                        class="btn btn-primary btn-lg"
                        type="button"
                        @click="saveNumberSet()"
                      >
                        {{ $t("messages.general.save") }}</button
                      >&nbsp;&nbsp;&nbsp;
                      <button
                        class="btn btn-light btn-lg"
                        type="button"
                        @click="cancelNumberSet()"
                      >
                        {{ $t("messages.general.cancel") }}</button
                      >&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="dialogStudentsShowDetail"
            hide-overlay
            scrollable
            max-width="80%"
            content-class="dlgCustomHeight"
          >
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>search</v-icon>
                <v-toolbar-title>{{
                  $t("messages.confirmReqRegister.studentReqList")
                }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogStudentsShowDetail = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark style="height: 100%;">
                <form>
                  <div
                    class="form-row flex-column justify-content-center align-items-center mt-5"
                  >
                    <div class="form-group" style="width: 100%">
                      <div class="form-inline">
                        <div
                          class="form-group"
                          style="width: 70%; justify-content: left;"
                        >
                          <label class="text-danger">{{
                            $t("messages.confirmReqRegister.remarkStudent")
                          }}</label>
                        </div>
                        <div
                          class="form-group"
                          style="width: 30%; justify-content: flex-end;"
                        >
                          <div class="form-inline"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
                <v-card
                  style="height: 100%; overflowX: auto; position: relative;"
                >
                  <b-table
                    bordered
                    hover
                    small
                    responsive
                    caption-top
                    class="table table-striped text-center"
                    :sort-by.sync="bTableStudentRegShow.sortBy"
                    :sort-desc.sync="bTableStudentRegShow.sortDesc"
                    :items="bTableStudentRegShow.items"
                    :fields="bTableStudentRegShow.fields"
                    :per-page="perPageStudentReg"
                    :current-page="currentPageStudentReg"
                    style="position: relative; overflowY: hidden; padding-bottom: 55px"
                  >
                    <template slot="table-caption">
                      <div>
                        <div class="float-left">
                          <b class="mr-2">{{
                            $t("messages.general.table.paginationinfo")
                          }}</b>
                          <b-form-select
                            v-model="perPageStudentReg"
                            :options="perPageOptions"
                            size="sm"
                            style="width:70px"
                          />
                        </div>
                        <b-pagination
                          class="float-right"
                          size="sm"
                          :total-rows="bTableStudentRegShow.items.length"
                          v-model="currentPageStudentReg"
                          :per-page="perPageStudentReg"
                        />
                        <div
                          v-if="bTableStudentRegShow.items.length > 0"
                          class="float-right data-table-page-info"
                        >
                          {{
                            Number(
                              currentPageStudentReg > 1
                                ? (currentPageStudentReg - 1) *
                                    perPageStudentReg +
                                    1
                                : currentPageStudentReg
                            ).toLocaleString()
                          }}
                          -
                          {{
                            Number(
                              currentPageStudentReg * perPageStudentReg >
                                bTableStudentRegShow.items.length
                                ? bTableStudentRegShow.items.length
                                : currentPageStudentReg * perPageStudentReg
                            ).toLocaleString()
                          }}
                          {{ $t("messages.general.fromRecords") }}
                          {{
                            Number(
                              bTableStudentRegShow.items.length
                            ).toLocaleString()
                          }}
                        </div>
                        <div
                          v-if="bTableStudentRegShow.items.length <= 0"
                          class="float-right data-table-page-info"
                        >
                          0 - 0
                          {{ $t("messages.general.fromRecords") }}
                          {{
                            Number(
                              bTableStudentRegShow.items.length
                            ).toLocaleString()
                          }}
                        </div>
                      </div>
                    </template>
                    <template v-slot:cell(STUDENTCODE)="data">
                      <label
                        :class="
                          data.item.IS_RESERVE === 'Y' ? 'text-danger' : ''
                        "
                        >{{ data.value }}</label
                      >
                    </template>

                    <template slot="table-caption">
                      <div
                        style="position: absolute; bottom: -7px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                      >
                        <div class="float-left">
                          <b class="mr-2">{{
                            $t("messages.general.table.paginationinfo")
                          }}</b>
                          <b-form-select
                            v-model="perPageStudentReg"
                            :options="perPageOptions"
                            size="sm"
                            style="width:70px"
                          />
                        </div>
                        <b-pagination
                          class="float-right"
                          size="sm"
                          :total-rows="bTableStudentRegShow.items.length"
                          v-model="currentPageStudentReg"
                          :per-page="perPageStudentReg"
                          style="padding-top: 10px"
                        />
                        <div
                          v-if="bTableStudentRegShow.items.length > 0"
                          class="float-right data-table-page-info"
                          style="padding-top: 14px"
                        >
                          {{
                            Number(
                              currentPageStudentReg > 1
                                ? (currentPageStudentReg - 1) *
                                    perPageStudentReg +
                                    1
                                : currentPageStudentReg
                            ).toLocaleString()
                          }}
                          -
                          {{
                            Number(
                              currentPageStudentReg * perPageStudentReg >
                                bTableStudentRegShow.items.length
                                ? bTableStudentRegShow.items.length
                                : currentPageStudentReg * perPageStudentReg
                            ).toLocaleString()
                          }}
                          {{ $t("messages.general.fromRecords") }}
                          {{
                            Number(
                              bTableStudentRegShow.items.length
                            ).toLocaleString()
                          }}
                        </div>
                        <div
                          v-if="bTableStudentRegShow.items.length <= 0"
                          class="float-right data-table-page-info"
                          style="padding-top: 14px"
                        >
                          0 - 0
                          {{ $t("messages.general.fromRecords") }}
                          {{
                            Number(
                              bTableStudentRegShow.items.length
                            ).toLocaleString()
                          }}
                        </div>
                      </div>
                    </template>
                  </b-table>
                </v-card>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogStudents"
            hide-overlay
            scrollable
            max-width="80%"
            content-class="dlgCustomHeight"
          >
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>search</v-icon>
                <v-toolbar-title>{{
                  $t("messages.confirmReqRegister.studentReqList")
                }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogStudents = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark style="height: 100%;">
                <v-card
                  style="height: 100%; overflowX: auto; position: relative;"
                >
                  <b-table
                    bordered
                    hover
                    small
                    responsive
                    caption-top
                    class="table table-striped text-center"
                    :sort-by.sync="bTableStudentReg.sortBy"
                    :sort-desc.sync="bTableStudentReg.sortDesc"
                    :items="bTableStudentReg.items"
                    :fields="bTableStudentReg.fields"
                    :per-page="perPageStudentReg"
                    :current-page="currentPageStudentReg"
                    style="position: relative; overflowY: hidden; padding-bottom: 60px"
                  >
                    <template slot="table-caption">
                      <div>
                        <div class="float-left">
                          <b class="mr-2">{{
                            $t("messages.general.table.paginationinfo")
                          }}</b>
                          <b-form-select
                            v-model="perPageStudentReg"
                            :options="perPageOptions"
                            size="sm"
                            style="width:70px"
                          />
                        </div>
                        <b-pagination
                          class="float-right"
                          size="sm"
                          :total-rows="bTableStudentReg.items.length"
                          v-model="currentPageStudentReg"
                          :per-page="perPageStudentReg"
                        />
                        <div
                          v-if="bTableStudentReg.items.length > 0"
                          class="float-right data-table-page-info"
                        >
                          {{
                            Number(
                              currentPageStudentReg > 1
                                ? (currentPageStudentReg - 1) *
                                    perPageStudentReg +
                                    1
                                : currentPageStudentReg
                            ).toLocaleString()
                          }}
                          -
                          {{
                            Number(
                              currentPageStudentReg * perPageStudentReg >
                                bTableStudentReg.items.length
                                ? bTableStudentReg.items.length
                                : currentPageStudentReg * perPageStudentReg
                            ).toLocaleString()
                          }}
                          {{ $t("messages.general.fromRecords") }}
                          {{
                            Number(
                              bTableStudentReg.items.length
                            ).toLocaleString()
                          }}
                        </div>
                        <div
                          v-if="bTableStudentReg.items.length <= 0"
                          class="float-right data-table-page-info"
                        >
                          0 - 0
                          {{ $t("messages.general.fromRecords") }}
                          {{
                            Number(
                              bTableStudentReg.items.length
                            ).toLocaleString()
                          }}
                        </div>
                      </div>
                    </template>
                    <template v-slot:cell(STUDENTCODE_TEXT)="data">
                      <label
                        :class="
                          data.item.IS_RESERVE === 'Y' ? 'text-danger' : ''
                        "
                        >{{ data.value }}</label
                      >
                    </template>

                    <template slot="table-caption">
                      <div
                        style="position: absolute; bottom: -7px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                      >
                        <div class="float-left">
                          <b class="mr-2">{{
                            $t("messages.general.table.paginationinfo")
                          }}</b>
                          <b-form-select
                            v-model="perPageStudentReg"
                            :options="perPageOptions"
                            size="sm"
                            style="width:70px"
                          />
                        </div>
                        <b-pagination
                          class="float-right"
                          size="sm"
                          :total-rows="bTableStudentReg.items.length"
                          v-model="currentPageStudentReg"
                          :per-page="perPageStudentReg"
                          style="padding-top: 10px"
                        />
                        <div
                          v-if="bTableStudentReg.items.length > 0"
                          class="float-right data-table-page-info"
                          style="padding-top: 14px"
                        >
                          {{
                            Number(
                              currentPageStudentReg > 1
                                ? (currentPageStudentReg - 1) *
                                    perPageStudentReg +
                                    1
                                : currentPageStudentReg
                            ).toLocaleString()
                          }}
                          -
                          {{
                            Number(
                              currentPageStudentReg * perPageStudentReg >
                                bTableStudentReg.items.length
                                ? bTableStudentReg.items.length
                                : currentPageStudentReg * perPageStudentReg
                            ).toLocaleString()
                          }}
                          {{ $t("messages.general.fromRecords") }}
                          {{
                            Number(
                              bTableStudentReg.items.length
                            ).toLocaleString()
                          }}
                        </div>
                        <div
                          v-if="bTableStudentReg.items.length <= 0"
                          class="float-right data-table-page-info"
                          style="padding-top: 14px"
                        >
                          0 - 0
                          {{ $t("messages.general.fromRecords") }}
                          {{
                            Number(
                              bTableStudentReg.items.length
                            ).toLocaleString()
                          }}
                        </div>
                      </div>
                    </template>
                  </b-table>
                </v-card>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import AcademicYear from "../components/Dropdown/AcademicYear";
import Semester from "../components/Dropdown/Semester";
import Level from "@/components/Dropdown/Level.vue";
import Faculty from "@/components/Dropdown/Faculty.vue";
import Department from "@/components/Dropdown/Department.vue";
import StudentStatus from "@/components/Dropdown/StudentStatus.vue";
import MasterDataProvider from "@/services/masterData_provider";
import EnrollProvider from "@/services/enroll_provider";
import GetClassType from "@/components/Dropdown/GetClassType.vue";
import moment from "moment";
import "moment/locale/th";

const masterDataProvider = new MasterDataProvider();
const enrollProvider = new EnrollProvider();

export default {
  name: "updateRegisAmount",
  components: {
    AcademicYear,
    Semester,
    Level,
    Faculty,
    Department,
    StudentStatus,
    GetClassType,
  },
  data() {
    return {
      selYear: 0,
      selSemester: 0,
      selLvl: 0,
      selSection: "00",
      courseId: 0,
      courseCode: "",
      courseName: "",
      selected: 0,
      dialogSelected: false,
      dialogSearchProgram: false,
      dialogEditAmountMulti: false,
      isStudentSelect: true,
      dialogStudents: false,
      dialogStudentsShowDetail: false,
      bTableStudentReg: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [],
      },
      items: [
        {
          text: "---ไม่ระบุ---",
          value: 0,
        },
      ],
      value: [0],
      bTableProgram: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            sortable: true,
          },
          {
            key: "COURSENAME",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "COURSEUNIT",
            label: this.$t("messages.general.credit"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
        ],
      },
      bTable: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "COURSECODE",
            label: this.$t("messages.general.classId"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "COURSENAME",
            label: this.$t("messages.general.className"),
            thClass: "align-middle",
            thStyle: "width: 200px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "SECTION",
            label: this.$t("messages.general.section"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "ROOMNAME",
            label: this.$t("messages.general.room"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "CAPACITYLIST",
            label: this.$t("messages.general.roomCapacity"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-right text-nowarp",
            sortable: true,
          },
          {
            key: "CONFIRMQTY",
            label: this.$t("messages.general.comfirmRegReceiveAmt"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-right text-nowarp",
            sortable: true,
          },
          {
            key: "ENROLLSEAT",
            label: this.$t("messages.general.regisAmount"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-right text-nowarp",
            sortable: true,
          },
          {
            key: "TOTALSEAT",
            label: this.$t("messages.general.receiveAmount"),
            thClass: "align-middle",
            thStyle: "width: 80px",
            tdClass: "text-right text-nowarp",
            sortable: true,
          },
          {
            key: "TOTALSUMSEAT",
            label: this.$t("messages.general.improveAmount"),
            thClass: "align-right",
            thStyle: "width: 80px",
            tdClass: "text-right text-nowarp",
            sortable: true,
          },
        ],
      },
      bTableStudentRegShow: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "STUDENTCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 110px",
            sortable: true,
          },
          {
            key: "STUDENTNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "STUDENT_LEVEL",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "ENROLLSTATUS",
            label: this.$t("messages.general.regisStatus"),
            thClass: "align-middle",
            tdClass: "text-middle text-nowarp",
            sortable: true,
          },
        ],
      },
     perPageOptions: [
        { value: 10, text: 10 },
        { value: 50, text: 50 },
        { value: 100, text: 100 },
        { value: 500, text: 500 },
        { value: 1000, text: 1000 },
        { value: 2000, text: 2000 },
        { value: 3000, text: 3000 },
      ],
      perPage: 100,
      perPageStudentReg: 50,
      currentPage: 1,
      currentPageProgram: 1,
      currentPageStudentReserve: 1,
      currentPageStudentSearch: 1,
      dlgCourseCode: "",
      dlgCourseName: "",
      selDepartmentCourse: 0,
      selFacultyCourse: 0,
      sections: [],
      dialogConfirmSuccess: false,
      successText: "",
      dialogError: false,
      errorText: "",
      dialogErrorTitle: "",
      selClassId: 0,
      dlgImproveAmount: "",
      selFacultyStudent: 0,
      selDepartmentStudent: 0,
      selLvlStudent: 0,
      selStudentStatusFrom: 0,
      selStudentStatusTo: 0,
      selType: "",
      courseList: [],
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      mfuUserId: "getMfuUserId",
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
    currentyear: function() {
      return this.currentLang == "th"
        ? parseInt(moment().format("YYYY")) + 543
        : moment().format("YYYY");
    },
  },
  mounted() {
    this.tokenHealthChk();
    this.togglePreLoader(true);
    this.selYear = this.appInfo.data.ENROLL_ACADYEAR; //this.currentyear;
    this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
    this.selLvl = 3;
    this.selSection = "00";
    this.selType = "";
    this.togglePreLoader(false);
  },
  methods: {
    ...mapActions("application", ["togglePreLoader", "tokenHealthChk"]),
    onSelYearChanged(event) {
      this.selYear = parseInt(event.target.value);
      this.getSections();
    },
    onSelSemesterChanged(event) {
      this.selSemester = parseInt(event.target.value);
      this.getSections();
    },
    onSelLvlChanged(event) {
      this.selLvl = parseInt(event.target.value);
    },
    onSelFacultyCourseChanged() {
      this.selFacultyCourse = parseInt(event.target.value);
    },
    onSelDepartmentCourseChanged(event) {
      this.selDepartmentCourse = parseInt(event.target.value);
    },
    onSelFacultyStudentChanged() {
      this.selFacultyStudent = parseInt(event.target.value);
    },
    onSelDepartmentStudentChanged(event) {
      this.selDepartmentStudent = parseInt(event.target.value);
    },
    onSelLvlStudentChanged(event) {
      this.selLvlStudent = parseInt(event.target.value);
    },
    onSelStudentStatusFromChanged(event) {
      this.selStudentStatusFrom = parseInt(event.target.value);
    },
    onSelStudentStatusToChanged(event) {
      this.selStudentStatusTo = parseInt(event.target.value);
    },
    handleSearchClsKey(event) {
      if (event.charCode == 13) {
        this.handleSearchCls();
      }
    },
    onSelSectionChanged(event) {
      this.selSection = event.target.value;
    },
    // handleChg(e) {
    //   this.selSection = e;
    // },
    onSelTypeChanged(event) {
      this.selType = event.target.value;
    },
    async handleSearchCls() {
      if (this.courseCode != "") {
        this.togglePreLoader(true);
        const result = await enrollProvider.getCourseByAcad({
          token: this.token,
          request: {
            coursecode: this.courseCode,
            acadyear: this.selYear,
            semester: this.selSemester,
            levelid: this.selLvl,
            lang: this.currentLang,
          },
        });
        // Fix Dropdown Course List Found Multiple Course
        if (result.code != 500 && result.data.length > 0) {
          if (
            result.data.length == 1 ||
            result.data[0].COURSECODE == this.courseCode
          ) {
            this.handleSelectClass(result.data[0]);
            this.courseList = result;
          } else {
            this.courseList = result;
            this.dlgCourseCode = this.courseCode;
            this.dialogSearchProgram = true;
            this.bTableProgram.items = [];
            if (result.data.length > 0) {
              let idx = 0;
              result.data.map((d) => {
                d.rowNumber = idx + 1;
                this.bTableProgram.items.push(d);
                idx++;
              });
            }
          }
        } else {
          this.dialogError = true;
          this.errorText = result.message;
        }
        this.togglePreLoader(false);
      } else {
        this.handleShowDlgSearchCourse();
      }
    },
    handleClrScreen() {
      this.courseId = 0;
      this.courseCode = "";
      this.courseName = "";
    },
    async handleSelectClass(item) {
      if (item && item.COURSECODE !== null) {
        this.courseId = item.CLASSID;
        this.courseCode = item.COURSECODE;
        this.courseName = item.COURSENAME;
        await this.getSections();
      }
    },
    handleChkAll(e) {
      const isChecked = e.target.checked;
      this.bTable.items.map((i) => {
        i.action = e.target.checked;
        if (isChecked) {
          this.courseList.push(i);
          i.checked = true;
        } else {
          i.checked = false;
        }
      });
      if (!isChecked) {
        this.courseList = [];
      }
    },
    handleChk(e, data) {
      const isChecked = e.target.checked;
      const { item, index } = data;
      this.bTable.items[index].action = isChecked;
      item.checked = isChecked;
      if (isChecked) {
        this.courseList.push(item);
      } else {
        const newArr = this.courseList.filter((s) => s != item.CLASSID);
        this.courseList = newArr;
      }
    },
    async getSections() {
      if (this.selYear != 0 && this.selSemester != 0 && this.courseCode != "") {
        this.togglePreLoader(true);
        const data = await masterDataProvider.getSection({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            coursecode: this.courseCode,
            lang: this.currentLang,
          },
        });
        this.sections = data;
        const tmp = [
          {
            //text: "---ไม่ระบุ---",
            text: this.$t("messages.general.notSpecified"),
            value: "00",
          },
        ];
        data.forEach((d) => {
          tmp.push({
            text: d.SECTION_TEXT,
            value: d.SECTION_TEXT,
          });
        });
        this.items = tmp;
        console.log("items", this.items);
        this.togglePreLoader(false);
      }
    },
    handleShowDlgSearchCourse() {
      this.clearCourseProgram();
      this.dialogSearchProgram = true;
    },
    async handleCourseSearch() {
      //if (this.dlgCourseCode != "" || this.dlgCourseName != "") {
      this.togglePreLoader(true);
      const result = await enrollProvider.getCourseByAcad({
        token: this.token,
        request: {
          coursecode: this.dlgCourseCode,
          coursename: this.dlgCourseName,
          facultyid: this.selFacultyCourse,
          departmentid: this.selDepartmentCourse,
          acadyear: this.selYear,
          semester: this.selSemester,
          levelid: this.selLvl,
          lang: this.currentLang,
        },
      });
      this.bTableProgram.items = [];
      if (result.code != 500 && result.data.length > 0) {
        let idx = 0;
        result.data.map((d) => {
          d.rowNumber = idx + 1;
          this.bTableProgram.items.push(d);
          idx++;
        });
      } else {
        this.dialogError = true;
        this.errorText = result.message;
      }
      this.togglePreLoader(false);
      // } else {
      //   this.dialogError = true;
      //   this.errorText = this.$t("messages.general.programCodeNameReq");
      // }
    },
    clearCourseProgram() {
      this.dlgCourseCode = "";
      this.dlgCourseName = "";
      this.selFacultyCourse = 0;
      this.selDepartmentCourse = 0;
      this.bTableProgram.items = [];
    },
    async handleSelectCourse(item, idx) {
      console.log(idx);
      this.courseId = item.CLASSID;
      this.courseCode = item.COURSECODE;
      this.courseName = item.COURSENAME;
      this.handleSelectClass(item); //ส่งค่า courseid ปุ่มฟ้า
      await this.getSections();
      this.dialogSearchProgram = false;
    },
    async handleSearchResult() {
      if (
        this.selYear <= 0 ||
        this.selSemester <= 0 ||
        this.selLvl <= -1 ||
        this.selFaculty <= 0
      ) {
        return;
      }
      console.log("GetclassType handleSearchResult", this.selType);
      this.togglePreLoader(true);
      const result = await enrollProvider.getClassAdjustResult({
        token: this.token,
        request: {
          acadyear: this.selYear,
          semester: this.selSemester,
          levelid: this.selLvl,
          coursecode: this.courseCode,
          classtype: this.selType, //ฟิลดิ์ประเภทรายวิชา
          section: this.selSection,
          userid: this.mfuUserId,
          lang: this.currentLang,
        },
      });
      this.bTable.items = [];
      if (result.length > 0) {
        let idx = 0;
        result.map((d) => {
          d.rowNumber = idx + 1;
          d.TOTALSUMSEAT = d.TOTALSUMSEAT == null ? 0 : d.TOTALSUMSEAT;
          this.bTable.items.push(d);
          idx++;
        });
      }
      this.courseList = [];
      this.togglePreLoader(false);
    },

    // async handleStudentSelect() {
    //   if (this.isStudentSelect) {
    //     this.studentIdList = this.tmpStudentIdList;
    //     this.studentList = this.tmpStudentList;
    //   } else {
    //     const filterApiIds = [];
    //     const filterIds = [];
    //     const filterItems = [];
    //     this.tmpStudentList.forEach((s) => {
    //       if (s.isApi) {
    //         filterApiIds.push(s.STUDENTID);
    //       } else {
    //         const found = this.studentList.find(
    //           (t) => t.STUDENTID == s.STUDENTID
    //         );
    //         if (found == undefined) {
    //           filterItems.push(s);
    //           filterIds.push(s.STUDENTID);
    //         }
    //       }
    //     });
    //     if (filterApiIds.length > 0) {
    //       this.togglePreLoader(true);
    //       const res = await enrollProvider.delReqConfirmStudentDetail({
    //         token: this.token,
    //         request: {
    //           classid: this.selectedClsId,
    //           studentidlist: filterApiIds,
    //           userid: this.mfuUserId,
    //           lang: this.currentLang,
    //         },
    //       });
    //       this.togglePreLoader(false);
    //       if (res.code == 200) {
    //         this.dialogConfirmSuccess = true;
    //         this.successText = `${res.message}<br/>`;
    //       } else {
    //         this.dialogErrorTitle = "";
    //         this.dialogError = true;
    //         this.errorText = `${res.message}<br/>`;
    //       }
    //     }
    //     this.studentIdList = filterIds;
    //     this.studentList = filterItems;
    //   }
    //   this.dialogStudents = false;
    // },

    async handleSelectTotalEnroll(item, id) {
      this.classid = item.CLASSID;
      //this.handleStudentSelectList();
      this.isStudentSelect = false;
      this.bTableStudentReg.items = [];
      this.tmpStudentList = [];
      this.tmpStudentIdList = [];
      this.bTableStudentReg.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "STUDENTCODE_TEXT",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 110px",
          sortable: true,
        },
        {
          key: "STUDENTNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "STUDENT_LEVEL",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          thStyle: "width: 180px",
          sortable: true,
        },
      ];
      this.togglePreLoader(true);
      const res = await enrollProvider.getStdenrolldetail({
        token: this.token,
        request: {
          classid: item.CLASSID,
          lang: this.currentLang,
        },
      });
      let idx = 0;
      this.togglePreLoader(false);
      if (res.length > 0) {
        res.map((d) => {
          d.rowNumber = idx + 1;
          d.selStudent = false;
          d.isApi = true;
          this.bTableStudentReg.items.push(d);
          idx++;
        });
      }
      //  this.isHideButtonandMark = true;
      this.dialogStudents = true;
    },
    async handleSelectTotalConfirm(item, id) {
      this.classid = item.CLASSID;
      this.bTableStudentRegShow.items = [];
      this.togglePreLoader(true);
      const res = await enrollProvider.getStdconfirmdetail({
        token: this.token,
        request: {
          classid: item.CLASSID,
          lang: this.currentLang,
        },
      });
      let idx = 0;
      this.togglePreLoader(false);
      if (res.length > 0) {
        res.map((d) => {
          d.rowNumber = idx + 1;
          this.bTableStudentRegShow.items.push(d);
          idx++;
        });
      }
      this.dialogStudentsShowDetail = true;
    },
    async handleClearScreen() {
      this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
      this.selLvl = 3;
      this.selSection = "00";
      this.handleClrScreen();
      await this.getSections();
    },
    async handleSaveNumber() {
      this.togglePreLoader(true);
      const resIp = await masterDataProvider.getCurrentIP();
      const temp = {
        token: this.token,
        request: {
          classid_list: [],
          totalsumseat_list: [],
          ipaddress: resIp.ip,
          userid: this.mfuUserId,
          lang: this.currentLang,
        },
      };
      temp.request.classid_list = this.courseList.map((c) => {
        return c.CLASSID;
      });
      temp.request.totalsumseat_list = this.courseList.map((c) => {
        return parseInt(c.TOTALSUMSEAT);
      });
      const result = await enrollProvider.saveClassadJustResult(temp);
      if (result.status == 200) {
        this.dialogConfirmSuccess = true;
        this.successText = `${result.message}<br/>`;
        this.handleSearchResult();
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${result.message}`;
      }
      this.togglePreLoader(false);
    },
    async handleCancelNum() {
      this.courseList.forEach(async (c) => {
        const found = this.bTable.items.find((i) => i.CLASSID == c.CLASSID);
        found.TOTALSUMSEAT = 0;
        found.action = true;
        found.checked = true;
      });
    },
    EditNumberOfSet() {
      this.dlgImproveAmount = 0;
      this.dialogEditAmountMulti = true;
    },
    async saveNumberSet() {
      this.togglePreLoader(true);
      const resIp = await masterDataProvider.getCurrentIP();
      const temp = {
        token: this.token,
        request: {
          classid_list: [],
          totalsumseat_list: [],
          ipaddress: resIp.ip,
          userid: this.mfuUserId,
          lang: this.currentLang,
        },
      };
      temp.request.classid_list = this.bTable.items.map((c) => {
        return c.CLASSID;
      });
      temp.request.totalsumseat_list = this.bTable.items.map((c) => {
        return parseInt(this.dlgImproveAmount);
      });
      const result = await enrollProvider.saveClassadJustResult(temp);
      if (result.status == 200) {
        this.cancelNumberSet();
        this.handleSearchResult();
        this.dialogConfirmSuccess = true;
        this.successText = `${result.message}<br/>`;
      } else {
        this.dialogErrorTitle = "";
        this.dialogError = true;
        this.errorText = `${result.message}`;
      }

      this.togglePreLoader(false);
    },
    cancelNumberSet() {
      this.dlgImproveAmount = 0;
      this.dialogEditAmountMulti = false;
    },
  },
  watch: {
    currentLang() {
      this.bTableProgram.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          sortable: true,
        },
        {
          key: "COURSENAME",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "COURSEUNIT",
          label: this.$t("messages.general.credit"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
      ];
      this.bTableStudentRegShow.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "STUDENTCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 110px",
          sortable: true,
        },
        {
          key: "STUDENTNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "STUDENT_LEVEL",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "ENROLLSTATUS",
          label: this.$t("messages.general.regisStatus"),
          thClass: "align-middle",
          tdClass: "text-middle text-nowarp",
          sortable: true,
        },
      ];
      this.bTable.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "COURSECODE",
          label: this.$t("messages.general.classId"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "COURSENAME",
          label: this.$t("messages.general.className"),
          thClass: "align-middle",
          thStyle: "width: 200px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "SECTION",
          label: this.$t("messages.general.section"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "ROOMNAME",
          label: this.$t("messages.general.room"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "CAPACITYLIST",
          label: this.$t("messages.general.roomCapacity"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-right text-nowarp",
          sortable: true,
        },
        {
          key: "CONFIRMQTY",
          label: this.$t("messages.general.comfirmRegReceiveAmt"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-right text-nowarp",
          sortable: true,
        },
        {
          key: "ENROLLSEAT",
          label: this.$t("messages.general.regisAmount"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-right text-nowarp",
          sortable: true,
        },
        {
          key: "TOTALSEAT",
          label: this.$t("messages.general.receiveAmount"),
          thClass: "align-middle",
          thStyle: "width: 80px",
          tdClass: "text-right text-nowarp",
          sortable: true,
        },
        {
          key: "TOTALSUMSEAT",
          label: this.$t("messages.general.improveAmount"),
          thClass: "align-right",
          thStyle: "width: 80px",
          tdClass: "text-right text-nowarp",
          sortable: true,
        },
      ];

      if (this.isStudentSelect) {
        this.bTableStudentReg.fields = [
          {
            key: "selStudent",
            label: "",
            thClass: "align-middle",
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "STUDENTCODE_TEXT",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 110px",
            sortable: true,
          },
          {
            key: "STUDENTNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "STUDENT_LEVEL",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "REASON",
            label: this.$t("messages.general.reason"),
            thClass: "align-middle",
            thStyle: "width: 250px",
            tdClass: "text-left",
            sortable: true,
          },
        ];
      } else {
        this.bTableStudentReg.fields = [
          {
            key: "selStudent",
            label: "",
            thClass: "align-middle",
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thStyle: "width: 50px",
            thClass: "align-middle",
            sortable: true,
          },
          {
            key: "STUDENTCODE_TEXT",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 110px",
            sortable: true,
          },
          {
            key: "STUDENTNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "STUDENT_LEVEL",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
        ];
      }
    },
  },
};
</script>
